// source: io/codedrills/proto/content/content.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var io_codedrills_proto_judge_judge_pb = require('../../../../io/codedrills/proto/judge/judge_pb.js');
goog.object.extend(proto, io_codedrills_proto_judge_judge_pb);
var io_codedrills_proto_content_content_visibility_pb = require('../../../../io/codedrills/proto/content/content_visibility_pb.js');
goog.object.extend(proto, io_codedrills_proto_content_content_visibility_pb);
goog.exportSymbol('proto.io.codedrills.proto.content.Access', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.AntiCheating', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.AntiCheatingSettings', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Article', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Article.StatementCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Attachment', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.AutoCompleteSetting', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CachedContent', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CachedScoreboard', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CachedTeam', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CachedTeamMembership', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CachedUser', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CoachSetting', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Content', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentAddress', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentId', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentId.ByCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContentType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Contest', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContestMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ContestType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Ctc', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CustomAttribute', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.CustomAttributeType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Data', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Data.DataCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Drill', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillContent', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillContent.ContentCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.DrillSection', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.EvictCacheItem', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.EvictCacheItem.CacheItemCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.FieldPresence', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.FillInTheBlanks', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.FillInTheBlanksMatchType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.FreezeSettings', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Job', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.JobMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.JobPreference', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.JobSkill', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.JobType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.LanguageRestriction', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.MatchTheFollowing', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Mcq', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.McqMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.McqType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.MetaData', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.MetaData.ContentMetaCase', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ObjectiveOption', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.OrderTheFollowing', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.PaymentFrequency', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Permission', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.PublishType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.QuestionSelectionCriteria', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardSettings', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.ScoreboardType', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SelectionRule', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Skill', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SkillLevel', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.SkillMeta', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.StatusResponse', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Subjective', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TeamContestConfig', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TeamNameUniqueness', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.Test', null, global);
goog.exportSymbol('proto.io.codedrills.proto.content.TestMeta', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Content = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.Content, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Content.displayName = 'proto.io.codedrills.proto.content.Content';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Data = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.Data.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.Data, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Data.displayName = 'proto.io.codedrills.proto.content.Data';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.MetaData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.MetaData.repeatedFields_, proto.io.codedrills.proto.content.MetaData.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.MetaData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.MetaData.displayName = 'proto.io.codedrills.proto.content.MetaData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Article = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Article.repeatedFields_, proto.io.codedrills.proto.content.Article.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.Article, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Article.displayName = 'proto.io.codedrills.proto.content.Article';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Contest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Contest.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Contest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Contest.displayName = 'proto.io.codedrills.proto.content.Contest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Test = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Test.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Test, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Test.displayName = 'proto.io.codedrills.proto.content.Test';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.JobSkill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.JobSkill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.JobSkill.displayName = 'proto.io.codedrills.proto.content.JobSkill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Job = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Job.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Job, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Job.displayName = 'proto.io.codedrills.proto.content.Job';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.AntiCheating = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.AntiCheating, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.AntiCheating.displayName = 'proto.io.codedrills.proto.content.AntiCheating';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Drill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Drill.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Drill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Drill.displayName = 'proto.io.codedrills.proto.content.Drill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillSection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.DrillSection.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.DrillSection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillSection.displayName = 'proto.io.codedrills.proto.content.DrillSection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.DrillContent.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.DrillContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillContent.displayName = 'proto.io.codedrills.proto.content.DrillContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Mcq = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Mcq.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Mcq, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Mcq.displayName = 'proto.io.codedrills.proto.content.Mcq';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ObjectiveOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ObjectiveOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ObjectiveOption.displayName = 'proto.io.codedrills.proto.content.ObjectiveOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.McqMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.McqMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.McqMeta.displayName = 'proto.io.codedrills.proto.content.McqMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SkillMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.SkillMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SkillMeta.displayName = 'proto.io.codedrills.proto.content.SkillMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Skill = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Skill.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Skill, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Skill.displayName = 'proto.io.codedrills.proto.content.Skill';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.QuestionSelectionCriteria.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.QuestionSelectionCriteria, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.QuestionSelectionCriteria.displayName = 'proto.io.codedrills.proto.content.QuestionSelectionCriteria';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.SelectionRule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.SelectionRule.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.SelectionRule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.SelectionRule.displayName = 'proto.io.codedrills.proto.content.SelectionRule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Subjective = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.Subjective, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Subjective.displayName = 'proto.io.codedrills.proto.content.Subjective';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.FillInTheBlanks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.FillInTheBlanks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.FillInTheBlanks.displayName = 'proto.io.codedrills.proto.content.FillInTheBlanks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.MatchTheFollowing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.MatchTheFollowing.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.MatchTheFollowing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.MatchTheFollowing.displayName = 'proto.io.codedrills.proto.content.MatchTheFollowing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.OrderTheFollowing = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.OrderTheFollowing.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.OrderTheFollowing, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.OrderTheFollowing.displayName = 'proto.io.codedrills.proto.content.OrderTheFollowing';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContestMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContestMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContestMeta.displayName = 'proto.io.codedrills.proto.content.ContestMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TeamContestConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.TeamContestConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TeamContestConfig.displayName = 'proto.io.codedrills.proto.content.TeamContestConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CustomAttribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CustomAttribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CustomAttribute.displayName = 'proto.io.codedrills.proto.content.CustomAttribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.AutoCompleteSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.AutoCompleteSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.AutoCompleteSetting.displayName = 'proto.io.codedrills.proto.content.AutoCompleteSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CoachSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CoachSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CoachSetting.displayName = 'proto.io.codedrills.proto.content.CoachSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.TestMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.TestMeta.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.TestMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.TestMeta.displayName = 'proto.io.codedrills.proto.content.TestMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Ctc = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.Ctc.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.Ctc, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Ctc.displayName = 'proto.io.codedrills.proto.content.Ctc';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.JobMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.JobMeta.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.JobMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.JobMeta.displayName = 'proto.io.codedrills.proto.content.JobMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.DrillMeta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.DrillMeta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.DrillMeta.displayName = 'proto.io.codedrills.proto.content.DrillMeta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Permission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.Permission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Permission.displayName = 'proto.io.codedrills.proto.content.Permission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContentId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.ContentId.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.ContentId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContentId.displayName = 'proto.io.codedrills.proto.content.ContentId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ContentAddress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ContentAddress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ContentAddress.displayName = 'proto.io.codedrills.proto.content.ContentAddress';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.Attachment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.Attachment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.Attachment.displayName = 'proto.io.codedrills.proto.content.Attachment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.StatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.StatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.StatusResponse.displayName = 'proto.io.codedrills.proto.content.StatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.ScoreboardSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.ScoreboardSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.ScoreboardSettings.displayName = 'proto.io.codedrills.proto.content.ScoreboardSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.FreezeSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.FreezeSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.FreezeSettings.displayName = 'proto.io.codedrills.proto.content.FreezeSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.EvictCacheItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_);
};
goog.inherits(proto.io.codedrills.proto.content.EvictCacheItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.EvictCacheItem.displayName = 'proto.io.codedrills.proto.content.EvictCacheItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CachedContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CachedContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CachedContent.displayName = 'proto.io.codedrills.proto.content.CachedContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CachedTeam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CachedTeam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CachedTeam.displayName = 'proto.io.codedrills.proto.content.CachedTeam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CachedScoreboard = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CachedScoreboard, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CachedScoreboard.displayName = 'proto.io.codedrills.proto.content.CachedScoreboard';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CachedTeamMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CachedTeamMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CachedTeamMembership.displayName = 'proto.io.codedrills.proto.content.CachedTeamMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.CachedUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.io.codedrills.proto.content.CachedUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.CachedUser.displayName = 'proto.io.codedrills.proto.content.CachedUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.io.codedrills.proto.content.LanguageRestriction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.io.codedrills.proto.content.LanguageRestriction.repeatedFields_, null);
};
goog.inherits(proto.io.codedrills.proto.content.LanguageRestriction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.io.codedrills.proto.content.LanguageRestriction.displayName = 'proto.io.codedrills.proto.content.LanguageRestriction';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Content.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Content.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Content} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Content.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    version: jspb.Message.getFieldWithDefault(msg, 2, 0),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    url: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createdOn: jspb.Message.getFieldWithDefault(msg, 7, 0),
    updatedBy: jspb.Message.getFieldWithDefault(msg, 8, ""),
    updatedOn: jspb.Message.getFieldWithDefault(msg, 9, 0),
    contentType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    publishType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    metaData: (f = msg.getMetaData()) && proto.io.codedrills.proto.content.MetaData.toObject(includeInstance, f),
    data: (f = msg.getData()) && proto.io.codedrills.proto.content.Data.toObject(includeInstance, f),
    publishVersion: jspb.Message.getFieldWithDefault(msg, 14, 0),
    customerId: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.content.Content.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Content;
  return proto.io.codedrills.proto.content.Content.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Content} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Content}
 */
proto.io.codedrills.proto.content.Content.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedOn(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedBy(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedOn(value);
      break;
    case 10:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 11:
      var value = /** @type {!proto.io.codedrills.proto.content.PublishType} */ (reader.readEnum());
      msg.setPublishType(value);
      break;
    case 12:
      var value = new proto.io.codedrills.proto.content.MetaData;
      reader.readMessage(value,proto.io.codedrills.proto.content.MetaData.deserializeBinaryFromReader);
      msg.setMetaData(value);
      break;
    case 13:
      var value = new proto.io.codedrills.proto.content.Data;
      reader.readMessage(value,proto.io.codedrills.proto.content.Data.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPublishVersion(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCustomerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Content.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Content.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Content} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Content.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedOn();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedBy();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUpdatedOn();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getPublishType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getMetaData();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.io.codedrills.proto.content.MetaData.serializeBinaryToWriter
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.io.codedrills.proto.content.Data.serializeBinaryToWriter
    );
  }
  f = message.getPublishVersion();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getCustomerId();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.Content.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.Content.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string created_by = 6;
 * @return {string}
 */
proto.io.codedrills.proto.content.Content.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 created_on = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getCreatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setCreatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string updated_by = 8;
 * @return {string}
 */
proto.io.codedrills.proto.content.Content.prototype.getUpdatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setUpdatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 updated_on = 9;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getUpdatedOn = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setUpdatedOn = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional ContentType content_type = 10;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.Content.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional PublishType publish_type = 11;
 * @return {!proto.io.codedrills.proto.content.PublishType}
 */
proto.io.codedrills.proto.content.Content.prototype.getPublishType = function() {
  return /** @type {!proto.io.codedrills.proto.content.PublishType} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.PublishType} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setPublishType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional MetaData meta_data = 12;
 * @return {?proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.content.Content.prototype.getMetaData = function() {
  return /** @type{?proto.io.codedrills.proto.content.MetaData} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.MetaData, 12));
};


/**
 * @param {?proto.io.codedrills.proto.content.MetaData|undefined} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
*/
proto.io.codedrills.proto.content.Content.prototype.setMetaData = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.clearMetaData = function() {
  return this.setMetaData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Content.prototype.hasMetaData = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional Data data = 13;
 * @return {?proto.io.codedrills.proto.content.Data}
 */
proto.io.codedrills.proto.content.Content.prototype.getData = function() {
  return /** @type{?proto.io.codedrills.proto.content.Data} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Data, 13));
};


/**
 * @param {?proto.io.codedrills.proto.content.Data|undefined} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
*/
proto.io.codedrills.proto.content.Content.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Content.prototype.hasData = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional int32 publish_version = 14;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getPublishVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setPublishVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 customer_id = 15;
 * @return {number}
 */
proto.io.codedrills.proto.content.Content.prototype.getCustomerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Content} returns this
 */
proto.io.codedrills.proto.content.Content.prototype.setCustomerId = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.Data.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.Data.DataCase = {
  DATA_NOT_SET: 0,
  PROBLEM: 1,
  ARTICLE: 2,
  CONTEST: 3,
  DRILL: 4,
  TEST: 5,
  MCQ: 6,
  SKILL: 7,
  SUBJECTIVE: 8,
  JOB: 9,
  FILL_IN_THE_BLANKS: 10,
  MATCH_THE_FOLLOWING: 11,
  ORDER_THE_FOLLOWING: 12
};

/**
 * @return {proto.io.codedrills.proto.content.Data.DataCase}
 */
proto.io.codedrills.proto.content.Data.prototype.getDataCase = function() {
  return /** @type {proto.io.codedrills.proto.content.Data.DataCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.Data.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Data.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Data.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Data} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Data.toObject = function(includeInstance, msg) {
  var f, obj = {
    problem: (f = msg.getProblem()) && io_codedrills_proto_judge_judge_pb.Problem.toObject(includeInstance, f),
    article: (f = msg.getArticle()) && proto.io.codedrills.proto.content.Article.toObject(includeInstance, f),
    contest: (f = msg.getContest()) && proto.io.codedrills.proto.content.Contest.toObject(includeInstance, f),
    drill: (f = msg.getDrill()) && proto.io.codedrills.proto.content.Drill.toObject(includeInstance, f),
    test: (f = msg.getTest()) && proto.io.codedrills.proto.content.Test.toObject(includeInstance, f),
    mcq: (f = msg.getMcq()) && proto.io.codedrills.proto.content.Mcq.toObject(includeInstance, f),
    skill: (f = msg.getSkill()) && proto.io.codedrills.proto.content.Skill.toObject(includeInstance, f),
    subjective: (f = msg.getSubjective()) && proto.io.codedrills.proto.content.Subjective.toObject(includeInstance, f),
    job: (f = msg.getJob()) && proto.io.codedrills.proto.content.Job.toObject(includeInstance, f),
    fillInTheBlanks: (f = msg.getFillInTheBlanks()) && proto.io.codedrills.proto.content.FillInTheBlanks.toObject(includeInstance, f),
    matchTheFollowing: (f = msg.getMatchTheFollowing()) && proto.io.codedrills.proto.content.MatchTheFollowing.toObject(includeInstance, f),
    orderTheFollowing: (f = msg.getOrderTheFollowing()) && proto.io.codedrills.proto.content.OrderTheFollowing.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Data}
 */
proto.io.codedrills.proto.content.Data.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Data;
  return proto.io.codedrills.proto.content.Data.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Data} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Data}
 */
proto.io.codedrills.proto.content.Data.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new io_codedrills_proto_judge_judge_pb.Problem;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.Problem.deserializeBinaryFromReader);
      msg.setProblem(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.Article;
      reader.readMessage(value,proto.io.codedrills.proto.content.Article.deserializeBinaryFromReader);
      msg.setArticle(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.Contest;
      reader.readMessage(value,proto.io.codedrills.proto.content.Contest.deserializeBinaryFromReader);
      msg.setContest(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.content.Drill;
      reader.readMessage(value,proto.io.codedrills.proto.content.Drill.deserializeBinaryFromReader);
      msg.setDrill(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.content.Test;
      reader.readMessage(value,proto.io.codedrills.proto.content.Test.deserializeBinaryFromReader);
      msg.setTest(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.Mcq;
      reader.readMessage(value,proto.io.codedrills.proto.content.Mcq.deserializeBinaryFromReader);
      msg.setMcq(value);
      break;
    case 7:
      var value = new proto.io.codedrills.proto.content.Skill;
      reader.readMessage(value,proto.io.codedrills.proto.content.Skill.deserializeBinaryFromReader);
      msg.setSkill(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.content.Subjective;
      reader.readMessage(value,proto.io.codedrills.proto.content.Subjective.deserializeBinaryFromReader);
      msg.setSubjective(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.content.Job;
      reader.readMessage(value,proto.io.codedrills.proto.content.Job.deserializeBinaryFromReader);
      msg.setJob(value);
      break;
    case 10:
      var value = new proto.io.codedrills.proto.content.FillInTheBlanks;
      reader.readMessage(value,proto.io.codedrills.proto.content.FillInTheBlanks.deserializeBinaryFromReader);
      msg.setFillInTheBlanks(value);
      break;
    case 11:
      var value = new proto.io.codedrills.proto.content.MatchTheFollowing;
      reader.readMessage(value,proto.io.codedrills.proto.content.MatchTheFollowing.deserializeBinaryFromReader);
      msg.setMatchTheFollowing(value);
      break;
    case 12:
      var value = new proto.io.codedrills.proto.content.OrderTheFollowing;
      reader.readMessage(value,proto.io.codedrills.proto.content.OrderTheFollowing.deserializeBinaryFromReader);
      msg.setOrderTheFollowing(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Data.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Data.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Data} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Data.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProblem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      io_codedrills_proto_judge_judge_pb.Problem.serializeBinaryToWriter
    );
  }
  f = message.getArticle();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.content.Article.serializeBinaryToWriter
    );
  }
  f = message.getContest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.Contest.serializeBinaryToWriter
    );
  }
  f = message.getDrill();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.content.Drill.serializeBinaryToWriter
    );
  }
  f = message.getTest();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.content.Test.serializeBinaryToWriter
    );
  }
  f = message.getMcq();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.content.Mcq.serializeBinaryToWriter
    );
  }
  f = message.getSkill();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.content.Skill.serializeBinaryToWriter
    );
  }
  f = message.getSubjective();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.content.Subjective.serializeBinaryToWriter
    );
  }
  f = message.getJob();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.content.Job.serializeBinaryToWriter
    );
  }
  f = message.getFillInTheBlanks();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.io.codedrills.proto.content.FillInTheBlanks.serializeBinaryToWriter
    );
  }
  f = message.getMatchTheFollowing();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.io.codedrills.proto.content.MatchTheFollowing.serializeBinaryToWriter
    );
  }
  f = message.getOrderTheFollowing();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.io.codedrills.proto.content.OrderTheFollowing.serializeBinaryToWriter
    );
  }
};


/**
 * optional io.codedrills.proto.judge.Problem problem = 1;
 * @return {?proto.io.codedrills.proto.judge.Problem}
 */
proto.io.codedrills.proto.content.Data.prototype.getProblem = function() {
  return /** @type{?proto.io.codedrills.proto.judge.Problem} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_judge_judge_pb.Problem, 1));
};


/**
 * @param {?proto.io.codedrills.proto.judge.Problem|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setProblem = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearProblem = function() {
  return this.setProblem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasProblem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Article article = 2;
 * @return {?proto.io.codedrills.proto.content.Article}
 */
proto.io.codedrills.proto.content.Data.prototype.getArticle = function() {
  return /** @type{?proto.io.codedrills.proto.content.Article} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Article, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.Article|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setArticle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearArticle = function() {
  return this.setArticle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasArticle = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Contest contest = 3;
 * @return {?proto.io.codedrills.proto.content.Contest}
 */
proto.io.codedrills.proto.content.Data.prototype.getContest = function() {
  return /** @type{?proto.io.codedrills.proto.content.Contest} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Contest, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.Contest|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setContest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearContest = function() {
  return this.setContest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasContest = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Drill drill = 4;
 * @return {?proto.io.codedrills.proto.content.Drill}
 */
proto.io.codedrills.proto.content.Data.prototype.getDrill = function() {
  return /** @type{?proto.io.codedrills.proto.content.Drill} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Drill, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.Drill|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setDrill = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearDrill = function() {
  return this.setDrill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasDrill = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Test test = 5;
 * @return {?proto.io.codedrills.proto.content.Test}
 */
proto.io.codedrills.proto.content.Data.prototype.getTest = function() {
  return /** @type{?proto.io.codedrills.proto.content.Test} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Test, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.Test|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setTest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearTest = function() {
  return this.setTest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasTest = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Mcq mcq = 6;
 * @return {?proto.io.codedrills.proto.content.Mcq}
 */
proto.io.codedrills.proto.content.Data.prototype.getMcq = function() {
  return /** @type{?proto.io.codedrills.proto.content.Mcq} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Mcq, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.Mcq|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setMcq = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearMcq = function() {
  return this.setMcq(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasMcq = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Skill skill = 7;
 * @return {?proto.io.codedrills.proto.content.Skill}
 */
proto.io.codedrills.proto.content.Data.prototype.getSkill = function() {
  return /** @type{?proto.io.codedrills.proto.content.Skill} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Skill, 7));
};


/**
 * @param {?proto.io.codedrills.proto.content.Skill|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setSkill = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearSkill = function() {
  return this.setSkill(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasSkill = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Subjective subjective = 8;
 * @return {?proto.io.codedrills.proto.content.Subjective}
 */
proto.io.codedrills.proto.content.Data.prototype.getSubjective = function() {
  return /** @type{?proto.io.codedrills.proto.content.Subjective} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Subjective, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.Subjective|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setSubjective = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearSubjective = function() {
  return this.setSubjective(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasSubjective = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Job job = 9;
 * @return {?proto.io.codedrills.proto.content.Job}
 */
proto.io.codedrills.proto.content.Data.prototype.getJob = function() {
  return /** @type{?proto.io.codedrills.proto.content.Job} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Job, 9));
};


/**
 * @param {?proto.io.codedrills.proto.content.Job|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setJob = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearJob = function() {
  return this.setJob(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasJob = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional FillInTheBlanks fill_in_the_blanks = 10;
 * @return {?proto.io.codedrills.proto.content.FillInTheBlanks}
 */
proto.io.codedrills.proto.content.Data.prototype.getFillInTheBlanks = function() {
  return /** @type{?proto.io.codedrills.proto.content.FillInTheBlanks} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.FillInTheBlanks, 10));
};


/**
 * @param {?proto.io.codedrills.proto.content.FillInTheBlanks|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setFillInTheBlanks = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearFillInTheBlanks = function() {
  return this.setFillInTheBlanks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasFillInTheBlanks = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional MatchTheFollowing match_the_following = 11;
 * @return {?proto.io.codedrills.proto.content.MatchTheFollowing}
 */
proto.io.codedrills.proto.content.Data.prototype.getMatchTheFollowing = function() {
  return /** @type{?proto.io.codedrills.proto.content.MatchTheFollowing} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.MatchTheFollowing, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.MatchTheFollowing|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setMatchTheFollowing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearMatchTheFollowing = function() {
  return this.setMatchTheFollowing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasMatchTheFollowing = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional OrderTheFollowing order_the_following = 12;
 * @return {?proto.io.codedrills.proto.content.OrderTheFollowing}
 */
proto.io.codedrills.proto.content.Data.prototype.getOrderTheFollowing = function() {
  return /** @type{?proto.io.codedrills.proto.content.OrderTheFollowing} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.OrderTheFollowing, 12));
};


/**
 * @param {?proto.io.codedrills.proto.content.OrderTheFollowing|undefined} value
 * @return {!proto.io.codedrills.proto.content.Data} returns this
*/
proto.io.codedrills.proto.content.Data.prototype.setOrderTheFollowing = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.io.codedrills.proto.content.Data.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Data} returns this
 */
proto.io.codedrills.proto.content.Data.prototype.clearOrderTheFollowing = function() {
  return this.setOrderTheFollowing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Data.prototype.hasOrderTheFollowing = function() {
  return jspb.Message.getField(this, 12) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.MetaData.repeatedFields_ = [2];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.MetaData.oneofGroups_ = [[4,6,8,9,11,13,15]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.MetaData.ContentMetaCase = {
  CONTENT_META_NOT_SET: 0,
  PROBLEM_META: 4,
  CONTEST_META: 6,
  TEST_META: 8,
  DRILL_META: 9,
  MCQ_META: 11,
  SKILL_META: 13,
  JOB_META: 15
};

/**
 * @return {proto.io.codedrills.proto.content.MetaData.ContentMetaCase}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getContentMetaCase = function() {
  return /** @type {proto.io.codedrills.proto.content.MetaData.ContentMetaCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.MetaData.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.MetaData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.MetaData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MetaData.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionsMap: (f = msg.getPermissionsMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.content.Permission.toObject) : [],
    tagsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    rating: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    problemMeta: (f = msg.getProblemMeta()) && io_codedrills_proto_judge_judge_pb.ProblemMeta.toObject(includeInstance, f),
    contestMeta: (f = msg.getContestMeta()) && proto.io.codedrills.proto.content.ContestMeta.toObject(includeInstance, f),
    testMeta: (f = msg.getTestMeta()) && proto.io.codedrills.proto.content.TestMeta.toObject(includeInstance, f),
    drillMeta: (f = msg.getDrillMeta()) && proto.io.codedrills.proto.content.DrillMeta.toObject(includeInstance, f),
    mcqMeta: (f = msg.getMcqMeta()) && proto.io.codedrills.proto.content.McqMeta.toObject(includeInstance, f),
    skillMeta: (f = msg.getSkillMeta()) && proto.io.codedrills.proto.content.SkillMeta.toObject(includeInstance, f),
    jobMeta: (f = msg.getJobMeta()) && proto.io.codedrills.proto.content.JobMeta.toObject(includeInstance, f),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
    submissionVisibility: jspb.Message.getFieldWithDefault(msg, 10, 0),
    timeLimit: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    maxScore: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.content.MetaData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.MetaData;
  return proto.io.codedrills.proto.content.MetaData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.MetaData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.MetaData}
 */
proto.io.codedrills.proto.content.MetaData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getPermissionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.content.Permission.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.content.Permission());
         });
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRating(value);
      break;
    case 4:
      var value = new io_codedrills_proto_judge_judge_pb.ProblemMeta;
      reader.readMessage(value,io_codedrills_proto_judge_judge_pb.ProblemMeta.deserializeBinaryFromReader);
      msg.setProblemMeta(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.ContestMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContestMeta.deserializeBinaryFromReader);
      msg.setContestMeta(value);
      break;
    case 8:
      var value = new proto.io.codedrills.proto.content.TestMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.TestMeta.deserializeBinaryFromReader);
      msg.setTestMeta(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.content.DrillMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillMeta.deserializeBinaryFromReader);
      msg.setDrillMeta(value);
      break;
    case 11:
      var value = new proto.io.codedrills.proto.content.McqMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.McqMeta.deserializeBinaryFromReader);
      msg.setMcqMeta(value);
      break;
    case 13:
      var value = new proto.io.codedrills.proto.content.SkillMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.SkillMeta.deserializeBinaryFromReader);
      msg.setSkillMeta(value);
      break;
    case 15:
      var value = new proto.io.codedrills.proto.content.JobMeta;
      reader.readMessage(value,proto.io.codedrills.proto.content.JobMeta.deserializeBinaryFromReader);
      msg.setJobMeta(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 10:
      var value = /** @type {!proto.io.codedrills.proto.content.SubmissionVisibility} */ (reader.readEnum());
      msg.setSubmissionVisibility(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTimeLimit(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.MetaData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.MetaData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.MetaData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MetaData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(1, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.content.Permission.serializeBinaryToWriter);
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getRating();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getProblemMeta();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      io_codedrills_proto_judge_judge_pb.ProblemMeta.serializeBinaryToWriter
    );
  }
  f = message.getContestMeta();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.content.ContestMeta.serializeBinaryToWriter
    );
  }
  f = message.getTestMeta();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.io.codedrills.proto.content.TestMeta.serializeBinaryToWriter
    );
  }
  f = message.getDrillMeta();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.content.DrillMeta.serializeBinaryToWriter
    );
  }
  f = message.getMcqMeta();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.io.codedrills.proto.content.McqMeta.serializeBinaryToWriter
    );
  }
  f = message.getSkillMeta();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.io.codedrills.proto.content.SkillMeta.serializeBinaryToWriter
    );
  }
  f = message.getJobMeta();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.io.codedrills.proto.content.JobMeta.serializeBinaryToWriter
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSubmissionVisibility();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTimeLimit();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getMaxScore();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
};


/**
 * map<string, Permission> permissions = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.content.Permission>}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getPermissionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.content.Permission>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      proto.io.codedrills.proto.content.Permission));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearPermissionsMap = function() {
  this.getPermissionsMap().clear();
  return this;};


/**
 * repeated string tags = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional double rating = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getRating = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setRating = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional io.codedrills.proto.judge.ProblemMeta problem_meta = 4;
 * @return {?proto.io.codedrills.proto.judge.ProblemMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getProblemMeta = function() {
  return /** @type{?proto.io.codedrills.proto.judge.ProblemMeta} */ (
    jspb.Message.getWrapperField(this, io_codedrills_proto_judge_judge_pb.ProblemMeta, 4));
};


/**
 * @param {?proto.io.codedrills.proto.judge.ProblemMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setProblemMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearProblemMeta = function() {
  return this.setProblemMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasProblemMeta = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional ContestMeta contest_meta = 6;
 * @return {?proto.io.codedrills.proto.content.ContestMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getContestMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContestMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContestMeta, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContestMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setContestMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearContestMeta = function() {
  return this.setContestMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasContestMeta = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional TestMeta test_meta = 8;
 * @return {?proto.io.codedrills.proto.content.TestMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getTestMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.TestMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.TestMeta, 8));
};


/**
 * @param {?proto.io.codedrills.proto.content.TestMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setTestMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearTestMeta = function() {
  return this.setTestMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasTestMeta = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DrillMeta drill_meta = 9;
 * @return {?proto.io.codedrills.proto.content.DrillMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getDrillMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.DrillMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.DrillMeta, 9));
};


/**
 * @param {?proto.io.codedrills.proto.content.DrillMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setDrillMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearDrillMeta = function() {
  return this.setDrillMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasDrillMeta = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional McqMeta mcq_meta = 11;
 * @return {?proto.io.codedrills.proto.content.McqMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getMcqMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.McqMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.McqMeta, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.McqMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setMcqMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearMcqMeta = function() {
  return this.setMcqMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasMcqMeta = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional SkillMeta skill_meta = 13;
 * @return {?proto.io.codedrills.proto.content.SkillMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getSkillMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.SkillMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.SkillMeta, 13));
};


/**
 * @param {?proto.io.codedrills.proto.content.SkillMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setSkillMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearSkillMeta = function() {
  return this.setSkillMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasSkillMeta = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional JobMeta job_meta = 15;
 * @return {?proto.io.codedrills.proto.content.JobMeta}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getJobMeta = function() {
  return /** @type{?proto.io.codedrills.proto.content.JobMeta} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.JobMeta, 15));
};


/**
 * @param {?proto.io.codedrills.proto.content.JobMeta|undefined} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
*/
proto.io.codedrills.proto.content.MetaData.prototype.setJobMeta = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.io.codedrills.proto.content.MetaData.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.clearJobMeta = function() {
  return this.setJobMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.MetaData.prototype.hasJobMeta = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string image_url = 7;
 * @return {string}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional SubmissionVisibility submission_visibility = 10;
 * @return {!proto.io.codedrills.proto.content.SubmissionVisibility}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getSubmissionVisibility = function() {
  return /** @type {!proto.io.codedrills.proto.content.SubmissionVisibility} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.SubmissionVisibility} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setSubmissionVisibility = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional double time_limit = 12;
 * @return {number}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getTimeLimit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setTimeLimit = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double max_score = 14;
 * @return {number}
 */
proto.io.codedrills.proto.content.MetaData.prototype.getMaxScore = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.MetaData} returns this
 */
proto.io.codedrills.proto.content.MetaData.prototype.setMaxScore = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Article.repeatedFields_ = [3];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.Article.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.Article.StatementCase = {
  STATEMENT_NOT_SET: 0,
  STATEMENT_ID: 1,
  STATEMENT_STRING: 2
};

/**
 * @return {proto.io.codedrills.proto.content.Article.StatementCase}
 */
proto.io.codedrills.proto.content.Article.prototype.getStatementCase = function() {
  return /** @type {proto.io.codedrills.proto.content.Article.StatementCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.Article.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Article.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Article.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Article} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Article.toObject = function(includeInstance, msg) {
  var f, obj = {
    statementId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    statementString: jspb.Message.getFieldWithDefault(msg, 2, ""),
    attachmentsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Article}
 */
proto.io.codedrills.proto.content.Article.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Article;
  return proto.io.codedrills.proto.content.Article.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Article} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Article}
 */
proto.io.codedrills.proto.content.Article.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatementString(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAttachments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Article.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Article.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Article} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Article.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string statement_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Article.prototype.getStatementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.setStatementId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.Article.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.clearStatementId = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.Article.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Article.prototype.hasStatementId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string statement_string = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.Article.prototype.getStatementString = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.setStatementString = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.content.Article.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.clearStatementString = function() {
  return jspb.Message.setOneofField(this, 2, proto.io.codedrills.proto.content.Article.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Article.prototype.hasStatementString = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string attachments = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.Article.prototype.getAttachmentsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.addAttachments = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Article} returns this
 */
proto.io.codedrills.proto.content.Article.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Contest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Contest.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Contest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Contest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Contest.toObject = function(includeInstance, msg) {
  var f, obj = {
    about: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rules: jspb.Message.getFieldWithDefault(msg, 2, ""),
    announcementsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    problemsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    scoreboardSettings: (f = msg.getScoreboardSettings()) && proto.io.codedrills.proto.content.ScoreboardSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Contest}
 */
proto.io.codedrills.proto.content.Contest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Contest;
  return proto.io.codedrills.proto.content.Contest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Contest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Contest}
 */
proto.io.codedrills.proto.content.Contest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRules(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnnouncements(value);
      break;
    case 4:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setProblemsList(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.ScoreboardSettings;
      reader.readMessage(value,proto.io.codedrills.proto.content.ScoreboardSettings.deserializeBinaryFromReader);
      msg.setScoreboardSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Contest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Contest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Contest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Contest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRules();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAnnouncementsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getProblemsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getScoreboardSettings();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.content.ScoreboardSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional string about = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Contest.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string rules = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.Contest.prototype.getRules = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.setRules = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string announcements = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.Contest.prototype.getAnnouncementsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.setAnnouncementsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.addAnnouncements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.clearAnnouncementsList = function() {
  return this.setAnnouncementsList([]);
};


/**
 * repeated int32 problems = 4;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.Contest.prototype.getProblemsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.setProblemsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.addProblems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.clearProblemsList = function() {
  return this.setProblemsList([]);
};


/**
 * optional ScoreboardSettings scoreboard_settings = 6;
 * @return {?proto.io.codedrills.proto.content.ScoreboardSettings}
 */
proto.io.codedrills.proto.content.Contest.prototype.getScoreboardSettings = function() {
  return /** @type{?proto.io.codedrills.proto.content.ScoreboardSettings} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ScoreboardSettings, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.ScoreboardSettings|undefined} value
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
*/
proto.io.codedrills.proto.content.Contest.prototype.setScoreboardSettings = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Contest} returns this
 */
proto.io.codedrills.proto.content.Contest.prototype.clearScoreboardSettings = function() {
  return this.setScoreboardSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Contest.prototype.hasScoreboardSettings = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Test.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Test.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Test.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Test} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Test.toObject = function(includeInstance, msg) {
  var f, obj = {
    about: jspb.Message.getFieldWithDefault(msg, 1, ""),
    skillsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    role: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Test}
 */
proto.io.codedrills.proto.content.Test.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Test;
  return proto.io.codedrills.proto.content.Test.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Test} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Test}
 */
proto.io.codedrills.proto.content.Test.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setSkillsList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setJobId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Test.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Test.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Test} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Test.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSkillsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobId();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string about = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Test.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 skills = 2;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.Test.prototype.getSkillsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.setSkillsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.addSkills = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.clearSkillsList = function() {
  return this.setSkillsList([]);
};


/**
 * optional string role = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.Test.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 job_id = 5;
 * @return {number}
 */
proto.io.codedrills.proto.content.Test.prototype.getJobId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Test} returns this
 */
proto.io.codedrills.proto.content.Test.prototype.setJobId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.JobSkill.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.JobSkill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.JobSkill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobSkill.toObject = function(includeInstance, msg) {
  var f, obj = {
    skill: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.JobSkill}
 */
proto.io.codedrills.proto.content.JobSkill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.JobSkill;
  return proto.io.codedrills.proto.content.JobSkill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.JobSkill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.JobSkill}
 */
proto.io.codedrills.proto.content.JobSkill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSkill(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.JobSkill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.JobSkill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.JobSkill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobSkill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSkill();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string skill = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.JobSkill.prototype.getSkill = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.JobSkill} returns this
 */
proto.io.codedrills.proto.content.JobSkill.prototype.setSkill = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Job.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Job.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Job.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Job} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Job.toObject = function(includeInstance, msg) {
  var f, obj = {
    about: jspb.Message.getFieldWithDefault(msg, 1, ""),
    role: jspb.Message.getFieldWithDefault(msg, 2, ""),
    skillsList: jspb.Message.toObjectList(msg.getSkillsList(),
    proto.io.codedrills.proto.content.JobSkill.toObject, includeInstance),
    testId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Job}
 */
proto.io.codedrills.proto.content.Job.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Job;
  return proto.io.codedrills.proto.content.Job.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Job} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Job}
 */
proto.io.codedrills.proto.content.Job.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAbout(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRole(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.JobSkill;
      reader.readMessage(value,proto.io.codedrills.proto.content.JobSkill.deserializeBinaryFromReader);
      msg.addSkills(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Job.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Job.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Job} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Job.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAbout();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRole();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSkillsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.JobSkill.serializeBinaryToWriter
    );
  }
  f = message.getTestId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string about = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Job.prototype.getAbout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Job} returns this
 */
proto.io.codedrills.proto.content.Job.prototype.setAbout = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string role = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.Job.prototype.getRole = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Job} returns this
 */
proto.io.codedrills.proto.content.Job.prototype.setRole = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated JobSkill skills = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.JobSkill>}
 */
proto.io.codedrills.proto.content.Job.prototype.getSkillsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.JobSkill>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.JobSkill, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.JobSkill>} value
 * @return {!proto.io.codedrills.proto.content.Job} returns this
*/
proto.io.codedrills.proto.content.Job.prototype.setSkillsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.JobSkill=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.JobSkill}
 */
proto.io.codedrills.proto.content.Job.prototype.addSkills = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.JobSkill, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Job} returns this
 */
proto.io.codedrills.proto.content.Job.prototype.clearSkillsList = function() {
  return this.setSkillsList([]);
};


/**
 * optional int32 test_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.Job.prototype.getTestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Job} returns this
 */
proto.io.codedrills.proto.content.Job.prototype.setTestId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.AntiCheating.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.AntiCheating.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.AntiCheating} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.AntiCheating.toObject = function(includeInstance, msg) {
  var f, obj = {
    antiCheatingSettings: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.AntiCheating}
 */
proto.io.codedrills.proto.content.AntiCheating.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.AntiCheating;
  return proto.io.codedrills.proto.content.AntiCheating.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.AntiCheating} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.AntiCheating}
 */
proto.io.codedrills.proto.content.AntiCheating.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.AntiCheatingSettings} */ (reader.readEnum());
      msg.setAntiCheatingSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.AntiCheating.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.AntiCheating.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.AntiCheating} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.AntiCheating.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAntiCheatingSettings();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional AntiCheatingSettings anti_cheating_settings = 1;
 * @return {!proto.io.codedrills.proto.content.AntiCheatingSettings}
 */
proto.io.codedrills.proto.content.AntiCheating.prototype.getAntiCheatingSettings = function() {
  return /** @type {!proto.io.codedrills.proto.content.AntiCheatingSettings} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.AntiCheatingSettings} value
 * @return {!proto.io.codedrills.proto.content.AntiCheating} returns this
 */
proto.io.codedrills.proto.content.AntiCheating.prototype.setAntiCheatingSettings = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Drill.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Drill.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Drill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Drill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Drill.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    sectionsList: jspb.Message.toObjectList(msg.getSectionsList(),
    proto.io.codedrills.proto.content.DrillSection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Drill}
 */
proto.io.codedrills.proto.content.Drill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Drill;
  return proto.io.codedrills.proto.content.Drill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Drill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Drill}
 */
proto.io.codedrills.proto.content.Drill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.DrillSection;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillSection.deserializeBinaryFromReader);
      msg.addSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Drill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Drill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Drill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Drill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.DrillSection.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Drill.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Drill} returns this
 */
proto.io.codedrills.proto.content.Drill.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string image_url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.Drill.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Drill} returns this
 */
proto.io.codedrills.proto.content.Drill.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DrillSection sections = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.DrillSection>}
 */
proto.io.codedrills.proto.content.Drill.prototype.getSectionsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.DrillSection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.DrillSection, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.DrillSection>} value
 * @return {!proto.io.codedrills.proto.content.Drill} returns this
*/
proto.io.codedrills.proto.content.Drill.prototype.setSectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.DrillSection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.DrillSection}
 */
proto.io.codedrills.proto.content.Drill.prototype.addSections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.DrillSection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Drill} returns this
 */
proto.io.codedrills.proto.content.Drill.prototype.clearSectionsList = function() {
  return this.setSectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.DrillSection.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillSection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillSection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillSection.toObject = function(includeInstance, msg) {
  var f, obj = {
    title: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentsList: jspb.Message.toObjectList(msg.getContentsList(),
    proto.io.codedrills.proto.content.DrillContent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillSection}
 */
proto.io.codedrills.proto.content.DrillSection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillSection;
  return proto.io.codedrills.proto.content.DrillSection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillSection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillSection}
 */
proto.io.codedrills.proto.content.DrillSection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.DrillContent;
      reader.readMessage(value,proto.io.codedrills.proto.content.DrillContent.deserializeBinaryFromReader);
      msg.addContents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillSection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillSection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillSection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.DrillContent.serializeBinaryToWriter
    );
  }
};


/**
 * optional string title = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillSection} returns this
 */
proto.io.codedrills.proto.content.DrillSection.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.DrillSection} returns this
 */
proto.io.codedrills.proto.content.DrillSection.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated DrillContent contents = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.DrillContent>}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.getContentsList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.DrillContent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.DrillContent, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.DrillContent>} value
 * @return {!proto.io.codedrills.proto.content.DrillSection} returns this
*/
proto.io.codedrills.proto.content.DrillSection.prototype.setContentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.DrillContent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.DrillContent}
 */
proto.io.codedrills.proto.content.DrillSection.prototype.addContents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.DrillContent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.DrillSection} returns this
 */
proto.io.codedrills.proto.content.DrillSection.prototype.clearContentsList = function() {
  return this.setContentsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.DrillContent.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.DrillContent.ContentCase = {
  CONTENT_NOT_SET: 0,
  CONTENT_ID: 1
};

/**
 * @return {proto.io.codedrills.proto.content.DrillContent.ContentCase}
 */
proto.io.codedrills.proto.content.DrillContent.prototype.getContentCase = function() {
  return /** @type {proto.io.codedrills.proto.content.DrillContent.ContentCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.DrillContent.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillContent.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillContent}
 */
proto.io.codedrills.proto.content.DrillContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillContent;
  return proto.io.codedrills.proto.content.DrillContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillContent}
 */
proto.io.codedrills.proto.content.DrillContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.DrillContent.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.DrillContent} returns this
 */
proto.io.codedrills.proto.content.DrillContent.prototype.setContentId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.DrillContent.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.content.DrillContent} returns this
 */
proto.io.codedrills.proto.content.DrillContent.prototype.clearContentId = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.DrillContent.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.DrillContent.prototype.hasContentId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Mcq.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Mcq.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Mcq.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Mcq} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Mcq.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    optionList: jspb.Message.toObjectList(msg.getOptionList(),
    proto.io.codedrills.proto.content.ObjectiveOption.toObject, includeInstance),
    answerIdList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Mcq}
 */
proto.io.codedrills.proto.content.Mcq.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Mcq;
  return proto.io.codedrills.proto.content.Mcq.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Mcq} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Mcq}
 */
proto.io.codedrills.proto.content.Mcq.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOption;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader);
      msg.addOption(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addAnswerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Mcq.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Mcq.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Mcq} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Mcq.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOptionList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter
    );
  }
  f = message.getAnswerIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Mcq.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
 */
proto.io.codedrills.proto.content.Mcq.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOption option = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>}
 */
proto.io.codedrills.proto.content.Mcq.prototype.getOptionList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOption, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} value
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
*/
proto.io.codedrills.proto.content.Mcq.prototype.setOptionList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.Mcq.prototype.addOption = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
 */
proto.io.codedrills.proto.content.Mcq.prototype.clearOptionList = function() {
  return this.setOptionList([]);
};


/**
 * repeated string answer_id = 3;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.Mcq.prototype.getAnswerIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
 */
proto.io.codedrills.proto.content.Mcq.prototype.setAnswerIdList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
 */
proto.io.codedrills.proto.content.Mcq.prototype.addAnswerId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Mcq} returns this
 */
proto.io.codedrills.proto.content.Mcq.prototype.clearAnswerIdList = function() {
  return this.setAnswerIdList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ObjectiveOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ObjectiveOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    statement: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ObjectiveOption;
  return proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption} returns this
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string statement = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption} returns this
 */
proto.io.codedrills.proto.content.ObjectiveOption.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.McqMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.McqMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.McqMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.McqMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    mcqType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.McqMeta}
 */
proto.io.codedrills.proto.content.McqMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.McqMeta;
  return proto.io.codedrills.proto.content.McqMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.McqMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.McqMeta}
 */
proto.io.codedrills.proto.content.McqMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.McqType} */ (reader.readEnum());
      msg.setMcqType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.McqMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.McqMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.McqMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.McqMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMcqType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional McqType mcq_type = 1;
 * @return {!proto.io.codedrills.proto.content.McqType}
 */
proto.io.codedrills.proto.content.McqMeta.prototype.getMcqType = function() {
  return /** @type {!proto.io.codedrills.proto.content.McqType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.McqType} value
 * @return {!proto.io.codedrills.proto.content.McqMeta} returns this
 */
proto.io.codedrills.proto.content.McqMeta.prototype.setMcqType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SkillMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SkillMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SkillMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: jspb.Message.getFieldWithDefault(msg, 2, ""),
    skillLevel: jspb.Message.getFieldWithDefault(msg, 3, 0),
    imageUrl: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SkillMeta}
 */
proto.io.codedrills.proto.content.SkillMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SkillMeta;
  return proto.io.codedrills.proto.content.SkillMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SkillMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SkillMeta}
 */
proto.io.codedrills.proto.content.SkillMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.content.SkillLevel} */ (reader.readEnum());
      msg.setSkillLevel(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setImageUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SkillMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SkillMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SkillMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSkillLevel();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string summary = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SkillMeta} returns this
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SkillLevel skill_level = 3;
 * @return {!proto.io.codedrills.proto.content.SkillLevel}
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.getSkillLevel = function() {
  return /** @type {!proto.io.codedrills.proto.content.SkillLevel} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.SkillLevel} value
 * @return {!proto.io.codedrills.proto.content.SkillMeta} returns this
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.setSkillLevel = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string image_url = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.getImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.SkillMeta} returns this
 */
proto.io.codedrills.proto.content.SkillMeta.prototype.setImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Skill.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Skill.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Skill.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Skill} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Skill.toObject = function(includeInstance, msg) {
  var f, obj = {
    description: jspb.Message.getFieldWithDefault(msg, 1, ""),
    questionList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    expertDetails: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expertImageUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    languageRestriction: (f = msg.getLanguageRestriction()) && proto.io.codedrills.proto.content.LanguageRestriction.toObject(includeInstance, f),
    questionSelectionCriteria: (f = msg.getQuestionSelectionCriteria()) && proto.io.codedrills.proto.content.QuestionSelectionCriteria.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Skill}
 */
proto.io.codedrills.proto.content.Skill.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Skill;
  return proto.io.codedrills.proto.content.Skill.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Skill} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Skill}
 */
proto.io.codedrills.proto.content.Skill.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setQuestionList(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpertDetails(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpertImageUrl(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.content.LanguageRestriction;
      reader.readMessage(value,proto.io.codedrills.proto.content.LanguageRestriction.deserializeBinaryFromReader);
      msg.setLanguageRestriction(value);
      break;
    case 6:
      var value = new proto.io.codedrills.proto.content.QuestionSelectionCriteria;
      reader.readMessage(value,proto.io.codedrills.proto.content.QuestionSelectionCriteria.deserializeBinaryFromReader);
      msg.setQuestionSelectionCriteria(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Skill.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Skill.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Skill} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Skill.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQuestionList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
  f = message.getExpertDetails();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpertImageUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLanguageRestriction();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.content.LanguageRestriction.serializeBinaryToWriter
    );
  }
  f = message.getQuestionSelectionCriteria();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.io.codedrills.proto.content.QuestionSelectionCriteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional string description = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Skill.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated int32 question = 2;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.Skill.prototype.getQuestionList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.setQuestionList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.addQuestion = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.clearQuestionList = function() {
  return this.setQuestionList([]);
};


/**
 * optional string expert_details = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.Skill.prototype.getExpertDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.setExpertDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string expert_image_url = 4;
 * @return {string}
 */
proto.io.codedrills.proto.content.Skill.prototype.getExpertImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.setExpertImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LanguageRestriction language_restriction = 5;
 * @return {?proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.content.Skill.prototype.getLanguageRestriction = function() {
  return /** @type{?proto.io.codedrills.proto.content.LanguageRestriction} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.LanguageRestriction, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.LanguageRestriction|undefined} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
*/
proto.io.codedrills.proto.content.Skill.prototype.setLanguageRestriction = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.clearLanguageRestriction = function() {
  return this.setLanguageRestriction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Skill.prototype.hasLanguageRestriction = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional QuestionSelectionCriteria question_selection_criteria = 6;
 * @return {?proto.io.codedrills.proto.content.QuestionSelectionCriteria}
 */
proto.io.codedrills.proto.content.Skill.prototype.getQuestionSelectionCriteria = function() {
  return /** @type{?proto.io.codedrills.proto.content.QuestionSelectionCriteria} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.QuestionSelectionCriteria, 6));
};


/**
 * @param {?proto.io.codedrills.proto.content.QuestionSelectionCriteria|undefined} value
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
*/
proto.io.codedrills.proto.content.Skill.prototype.setQuestionSelectionCriteria = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.Skill} returns this
 */
proto.io.codedrills.proto.content.Skill.prototype.clearQuestionSelectionCriteria = function() {
  return this.setQuestionSelectionCriteria(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Skill.prototype.hasQuestionSelectionCriteria = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.QuestionSelectionCriteria.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.toObject = function(includeInstance, msg) {
  var f, obj = {
    selectionRuleList: jspb.Message.toObjectList(msg.getSelectionRuleList(),
    proto.io.codedrills.proto.content.SelectionRule.toObject, includeInstance),
    alwaysIncludedQuestionIdList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.QuestionSelectionCriteria;
  return proto.io.codedrills.proto.content.QuestionSelectionCriteria.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.SelectionRule;
      reader.readMessage(value,proto.io.codedrills.proto.content.SelectionRule.deserializeBinaryFromReader);
      msg.addSelectionRule(value);
      break;
    case 2:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt32());
      msg.setAlwaysIncludedQuestionIdList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.QuestionSelectionCriteria.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSelectionRuleList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.io.codedrills.proto.content.SelectionRule.serializeBinaryToWriter
    );
  }
  f = message.getAlwaysIncludedQuestionIdList();
  if (f.length > 0) {
    writer.writePackedInt32(
      2,
      f
    );
  }
};


/**
 * repeated SelectionRule selection_rule = 1;
 * @return {!Array<!proto.io.codedrills.proto.content.SelectionRule>}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.getSelectionRuleList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.SelectionRule>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.SelectionRule, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.SelectionRule>} value
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} returns this
*/
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.setSelectionRuleList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.SelectionRule=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SelectionRule}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.addSelectionRule = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.io.codedrills.proto.content.SelectionRule, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} returns this
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.clearSelectionRuleList = function() {
  return this.setSelectionRuleList([]);
};


/**
 * repeated int32 always_included_question_id = 2;
 * @return {!Array<number>}
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.getAlwaysIncludedQuestionIdList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} returns this
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.setAlwaysIncludedQuestionIdList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} returns this
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.addAlwaysIncludedQuestionId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.QuestionSelectionCriteria} returns this
 */
proto.io.codedrills.proto.content.QuestionSelectionCriteria.prototype.clearAlwaysIncludedQuestionIdList = function() {
  return this.setAlwaysIncludedQuestionIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.SelectionRule.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.SelectionRule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.SelectionRule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SelectionRule.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tagList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    numberOfQuestions: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.SelectionRule}
 */
proto.io.codedrills.proto.content.SelectionRule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.SelectionRule;
  return proto.io.codedrills.proto.content.SelectionRule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.SelectionRule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.SelectionRule}
 */
proto.io.codedrills.proto.content.SelectionRule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addTag(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumberOfQuestions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.SelectionRule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.SelectionRule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.SelectionRule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTagList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getNumberOfQuestions();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional ContentType content_type = 1;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.SelectionRule} returns this
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string tag = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.getTagList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.SelectionRule} returns this
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.setTagList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.SelectionRule} returns this
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.addTag = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.SelectionRule} returns this
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.clearTagList = function() {
  return this.setTagList([]);
};


/**
 * optional int32 number_of_questions = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.getNumberOfQuestions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.SelectionRule} returns this
 */
proto.io.codedrills.proto.content.SelectionRule.prototype.setNumberOfQuestions = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Subjective.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Subjective.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Subjective} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Subjective.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Subjective}
 */
proto.io.codedrills.proto.content.Subjective.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Subjective;
  return proto.io.codedrills.proto.content.Subjective.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Subjective} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Subjective}
 */
proto.io.codedrills.proto.content.Subjective.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Subjective.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Subjective.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Subjective} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Subjective.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Subjective.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Subjective} returns this
 */
proto.io.codedrills.proto.content.Subjective.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.FillInTheBlanks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FillInTheBlanks.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    answer: jspb.Message.getFieldWithDefault(msg, 2, ""),
    matchType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanks}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.FillInTheBlanks;
  return proto.io.codedrills.proto.content.FillInTheBlanks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanks}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnswer(value);
      break;
    case 3:
      var value = /** @type {!proto.io.codedrills.proto.content.FillInTheBlanksMatchType} */ (reader.readEnum());
      msg.setMatchType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.FillInTheBlanks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FillInTheBlanks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAnswer();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMatchType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanks} returns this
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string answer = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.getAnswer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanks} returns this
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.setAnswer = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional FillInTheBlanksMatchType match_type = 3;
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanksMatchType}
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.getMatchType = function() {
  return /** @type {!proto.io.codedrills.proto.content.FillInTheBlanksMatchType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.FillInTheBlanksMatchType} value
 * @return {!proto.io.codedrills.proto.content.FillInTheBlanks} returns this
 */
proto.io.codedrills.proto.content.FillInTheBlanks.prototype.setMatchType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.MatchTheFollowing.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.MatchTheFollowing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MatchTheFollowing.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    column1List: jspb.Message.toObjectList(msg.getColumn1List(),
    proto.io.codedrills.proto.content.ObjectiveOption.toObject, includeInstance),
    column2List: jspb.Message.toObjectList(msg.getColumn2List(),
    proto.io.codedrills.proto.content.ObjectiveOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.MatchTheFollowing;
  return proto.io.codedrills.proto.content.MatchTheFollowing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOption;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader);
      msg.addColumn1(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.ObjectiveOption;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader);
      msg.addColumn2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.MatchTheFollowing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.MatchTheFollowing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.MatchTheFollowing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumn1List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter
    );
  }
  f = message.getColumn2List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOption column1 = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.getColumn1List = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOption, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing} returns this
*/
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.setColumn1List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.addColumn1 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.clearColumn1List = function() {
  return this.setColumn1List([]);
};


/**
 * repeated ObjectiveOption column2 = 3;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.getColumn2List = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOption, 3));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} value
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing} returns this
*/
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.setColumn2List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.addColumn2 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.io.codedrills.proto.content.ObjectiveOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.MatchTheFollowing} returns this
 */
proto.io.codedrills.proto.content.MatchTheFollowing.prototype.clearColumn2List = function() {
  return this.setColumn2List([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.OrderTheFollowing.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.OrderTheFollowing.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.OrderTheFollowing.toObject = function(includeInstance, msg) {
  var f, obj = {
    statement: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceList: jspb.Message.toObjectList(msg.getSequenceList(),
    proto.io.codedrills.proto.content.ObjectiveOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowing}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.OrderTheFollowing;
  return proto.io.codedrills.proto.content.OrderTheFollowing.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowing}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatement(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ObjectiveOption;
      reader.readMessage(value,proto.io.codedrills.proto.content.ObjectiveOption.deserializeBinaryFromReader);
      msg.addSequence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.OrderTheFollowing.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.OrderTheFollowing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.OrderTheFollowing.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatement();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ObjectiveOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional string statement = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.getStatement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowing} returns this
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.setStatement = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated ObjectiveOption sequence = 2;
 * @return {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.getSequenceList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.ObjectiveOption, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.ObjectiveOption>} value
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowing} returns this
*/
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.setSequenceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.ObjectiveOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.ObjectiveOption}
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.addSequence = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.io.codedrills.proto.content.ObjectiveOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.OrderTheFollowing} returns this
 */
proto.io.codedrills.proto.content.OrderTheFollowing.prototype.clearSequenceList = function() {
  return this.setSequenceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContestMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContestMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContestMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    startAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    endAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
    contestType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    teamContestConfig: (f = msg.getTeamContestConfig()) && proto.io.codedrills.proto.content.TeamContestConfig.toObject(includeInstance, f),
    restrictSubmission: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    bannerUrl: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContestMeta}
 */
proto.io.codedrills.proto.content.ContestMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContestMeta;
  return proto.io.codedrills.proto.content.ContestMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContestMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContestMeta}
 */
proto.io.codedrills.proto.content.ContestMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndAt(value);
      break;
    case 10:
      var value = /** @type {!proto.io.codedrills.proto.content.ContestType} */ (reader.readEnum());
      msg.setContestType(value);
      break;
    case 11:
      var value = new proto.io.codedrills.proto.content.TeamContestConfig;
      reader.readMessage(value,proto.io.codedrills.proto.content.TeamContestConfig.deserializeBinaryFromReader);
      msg.setTeamContestConfig(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRestrictSubmission(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBannerUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContestMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContestMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContestMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getEndAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getContestType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getTeamContestConfig();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.io.codedrills.proto.content.TeamContestConfig.serializeBinaryToWriter
    );
  }
  f = message.getRestrictSubmission();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getBannerUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional int64 start_at = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getStartAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.setStartAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 end_at = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getEndAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.setEndAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional ContestType contest_type = 10;
 * @return {!proto.io.codedrills.proto.content.ContestType}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getContestType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContestType} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContestType} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.setContestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional TeamContestConfig team_contest_config = 11;
 * @return {?proto.io.codedrills.proto.content.TeamContestConfig}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getTeamContestConfig = function() {
  return /** @type{?proto.io.codedrills.proto.content.TeamContestConfig} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.TeamContestConfig, 11));
};


/**
 * @param {?proto.io.codedrills.proto.content.TeamContestConfig|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
*/
proto.io.codedrills.proto.content.ContestMeta.prototype.setTeamContestConfig = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.clearTeamContestConfig = function() {
  return this.setTeamContestConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.hasTeamContestConfig = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool restrict_submission = 12;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getRestrictSubmission = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.setRestrictSubmission = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string banner_url = 13;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.getBannerUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContestMeta} returns this
 */
proto.io.codedrills.proto.content.ContestMeta.prototype.setBannerUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TeamContestConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TeamContestConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamContestConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    minTeamSize: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maxTeamSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isEditable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    teamNameUniqueness: jspb.Message.getFieldWithDefault(msg, 4, 0),
    teamCustomAttributeMap: (f = msg.getTeamCustomAttributeMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.content.CustomAttribute.toObject) : [],
    memberCustomAttributeMap: (f = msg.getMemberCustomAttributeMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.content.CustomAttribute.toObject) : [],
    coachSetting: (f = msg.getCoachSetting()) && proto.io.codedrills.proto.content.CoachSetting.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig}
 */
proto.io.codedrills.proto.content.TeamContestConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TeamContestConfig;
  return proto.io.codedrills.proto.content.TeamContestConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TeamContestConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig}
 */
proto.io.codedrills.proto.content.TeamContestConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinTeamSize(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxTeamSize(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsEditable(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.content.TeamNameUniqueness} */ (reader.readEnum());
      msg.setTeamNameUniqueness(value);
      break;
    case 5:
      var value = msg.getTeamCustomAttributeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.content.CustomAttribute.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.content.CustomAttribute());
         });
      break;
    case 6:
      var value = msg.getMemberCustomAttributeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.content.CustomAttribute.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.content.CustomAttribute());
         });
      break;
    case 7:
      var value = new proto.io.codedrills.proto.content.CoachSetting;
      reader.readMessage(value,proto.io.codedrills.proto.content.CoachSetting.deserializeBinaryFromReader);
      msg.setCoachSetting(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TeamContestConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TeamContestConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TeamContestConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinTeamSize();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMaxTeamSize();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getIsEditable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTeamNameUniqueness();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTeamCustomAttributeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.content.CustomAttribute.serializeBinaryToWriter);
  }
  f = message.getMemberCustomAttributeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.content.CustomAttribute.serializeBinaryToWriter);
  }
  f = message.getCoachSetting();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.io.codedrills.proto.content.CoachSetting.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 min_team_size = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getMinTeamSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.setMinTeamSize = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 max_team_size = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getMaxTeamSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.setMaxTeamSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool is_editable = 3;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getIsEditable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.setIsEditable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional TeamNameUniqueness team_name_uniqueness = 4;
 * @return {!proto.io.codedrills.proto.content.TeamNameUniqueness}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getTeamNameUniqueness = function() {
  return /** @type {!proto.io.codedrills.proto.content.TeamNameUniqueness} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.TeamNameUniqueness} value
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.setTeamNameUniqueness = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * map<string, CustomAttribute> team_custom_attribute = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getTeamCustomAttributeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      proto.io.codedrills.proto.content.CustomAttribute));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.clearTeamCustomAttributeMap = function() {
  this.getTeamCustomAttributeMap().clear();
  return this;};


/**
 * map<string, CustomAttribute> member_custom_attribute = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getMemberCustomAttributeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      proto.io.codedrills.proto.content.CustomAttribute));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.clearMemberCustomAttributeMap = function() {
  this.getMemberCustomAttributeMap().clear();
  return this;};


/**
 * optional CoachSetting coach_setting = 7;
 * @return {?proto.io.codedrills.proto.content.CoachSetting}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.getCoachSetting = function() {
  return /** @type{?proto.io.codedrills.proto.content.CoachSetting} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CoachSetting, 7));
};


/**
 * @param {?proto.io.codedrills.proto.content.CoachSetting|undefined} value
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
*/
proto.io.codedrills.proto.content.TeamContestConfig.prototype.setCoachSetting = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.TeamContestConfig} returns this
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.clearCoachSetting = function() {
  return this.setCoachSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TeamContestConfig.prototype.hasCoachSetting = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CustomAttribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CustomAttribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CustomAttribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    customAttributeType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    autoCompleteSetting: (f = msg.getAutoCompleteSetting()) && proto.io.codedrills.proto.content.AutoCompleteSetting.toObject(includeInstance, f),
    customAttributePresence: jspb.Message.getFieldWithDefault(msg, 4, 0),
    customValueAllowed: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CustomAttribute}
 */
proto.io.codedrills.proto.content.CustomAttribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CustomAttribute;
  return proto.io.codedrills.proto.content.CustomAttribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CustomAttribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CustomAttribute}
 */
proto.io.codedrills.proto.content.CustomAttribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.CustomAttributeType} */ (reader.readEnum());
      msg.setCustomAttributeType(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.AutoCompleteSetting;
      reader.readMessage(value,proto.io.codedrills.proto.content.AutoCompleteSetting.deserializeBinaryFromReader);
      msg.setAutoCompleteSetting(value);
      break;
    case 4:
      var value = /** @type {!proto.io.codedrills.proto.content.FieldPresence} */ (reader.readEnum());
      msg.setCustomAttributePresence(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomValueAllowed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CustomAttribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CustomAttribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CustomAttribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCustomAttributeType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAutoCompleteSetting();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.AutoCompleteSetting.serializeBinaryToWriter
    );
  }
  f = message.getCustomAttributePresence();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCustomValueAllowed();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CustomAttributeType custom_attribute_type = 2;
 * @return {!proto.io.codedrills.proto.content.CustomAttributeType}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.getCustomAttributeType = function() {
  return /** @type {!proto.io.codedrills.proto.content.CustomAttributeType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.CustomAttributeType} value
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.setCustomAttributeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional AutoCompleteSetting auto_complete_setting = 3;
 * @return {?proto.io.codedrills.proto.content.AutoCompleteSetting}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.getAutoCompleteSetting = function() {
  return /** @type{?proto.io.codedrills.proto.content.AutoCompleteSetting} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.AutoCompleteSetting, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.AutoCompleteSetting|undefined} value
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
*/
proto.io.codedrills.proto.content.CustomAttribute.prototype.setAutoCompleteSetting = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.clearAutoCompleteSetting = function() {
  return this.setAutoCompleteSetting(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.hasAutoCompleteSetting = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FieldPresence custom_attribute_presence = 4;
 * @return {!proto.io.codedrills.proto.content.FieldPresence}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.getCustomAttributePresence = function() {
  return /** @type {!proto.io.codedrills.proto.content.FieldPresence} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.FieldPresence} value
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.setCustomAttributePresence = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool custom_value_allowed = 5;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.getCustomValueAllowed = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.CustomAttribute} returns this
 */
proto.io.codedrills.proto.content.CustomAttribute.prototype.setCustomValueAllowed = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.AutoCompleteSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.AutoCompleteSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    valueList: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.AutoCompleteSetting}
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.AutoCompleteSetting;
  return proto.io.codedrills.proto.content.AutoCompleteSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.AutoCompleteSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.AutoCompleteSetting}
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.AutoCompleteSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.AutoCompleteSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValueList();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value_list = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.prototype.getValueList = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.AutoCompleteSetting} returns this
 */
proto.io.codedrills.proto.content.AutoCompleteSetting.prototype.setValueList = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CoachSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CoachSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CoachSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    coachEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    coachPresence: jspb.Message.getFieldWithDefault(msg, 2, 0),
    coachCustomAttributeMap: (f = msg.getCoachCustomAttributeMap()) ? f.toObject(includeInstance, proto.io.codedrills.proto.content.CustomAttribute.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CoachSetting}
 */
proto.io.codedrills.proto.content.CoachSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CoachSetting;
  return proto.io.codedrills.proto.content.CoachSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CoachSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CoachSetting}
 */
proto.io.codedrills.proto.content.CoachSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoachEnabled(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.FieldPresence} */ (reader.readEnum());
      msg.setCoachPresence(value);
      break;
    case 3:
      var value = msg.getCoachCustomAttributeMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.io.codedrills.proto.content.CustomAttribute.deserializeBinaryFromReader, "", new proto.io.codedrills.proto.content.CustomAttribute());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CoachSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CoachSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CoachSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCoachEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCoachPresence();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCoachCustomAttributeMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(3, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.io.codedrills.proto.content.CustomAttribute.serializeBinaryToWriter);
  }
};


/**
 * optional bool coach_enabled = 1;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.getCoachEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.CoachSetting} returns this
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.setCoachEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional FieldPresence coach_presence = 2;
 * @return {!proto.io.codedrills.proto.content.FieldPresence}
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.getCoachPresence = function() {
  return /** @type {!proto.io.codedrills.proto.content.FieldPresence} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.FieldPresence} value
 * @return {!proto.io.codedrills.proto.content.CoachSetting} returns this
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.setCoachPresence = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * map<string, CustomAttribute> coach_custom_attribute = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>}
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.getCoachCustomAttributeMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.io.codedrills.proto.content.CustomAttribute>} */ (
      jspb.Message.getMapField(this, 3, opt_noLazyCreate,
      proto.io.codedrills.proto.content.CustomAttribute));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.io.codedrills.proto.content.CoachSetting} returns this
 */
proto.io.codedrills.proto.content.CoachSetting.prototype.clearCoachCustomAttributeMap = function() {
  this.getCoachCustomAttributeMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.TestMeta.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.TestMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.TestMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TestMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    durationInS: jspb.Message.getFieldWithDefault(msg, 1, 0),
    invited: jspb.Message.getFieldWithDefault(msg, 2, 0),
    completed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    antiCheatingList: jspb.Message.toObjectList(msg.getAntiCheatingList(),
    proto.io.codedrills.proto.content.AntiCheating.toObject, includeInstance),
    testByUrlEnabled: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    testUrlExpiry: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.TestMeta}
 */
proto.io.codedrills.proto.content.TestMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.TestMeta;
  return proto.io.codedrills.proto.content.TestMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.TestMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.TestMeta}
 */
proto.io.codedrills.proto.content.TestMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDurationInS(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInvited(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompleted(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.content.AntiCheating;
      reader.readMessage(value,proto.io.codedrills.proto.content.AntiCheating.deserializeBinaryFromReader);
      msg.addAntiCheating(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTestByUrlEnabled(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTestUrlExpiry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.TestMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.TestMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.TestMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDurationInS();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getInvited();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getCompleted();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAntiCheatingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.io.codedrills.proto.content.AntiCheating.serializeBinaryToWriter
    );
  }
  f = message.getTestByUrlEnabled();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getTestUrlExpiry();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 duration_in_s = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getDurationInS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.setDurationInS = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 invited = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getInvited = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.setInvited = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 completed = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getCompleted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.setCompleted = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated AntiCheating anti_cheating = 4;
 * @return {!Array<!proto.io.codedrills.proto.content.AntiCheating>}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getAntiCheatingList = function() {
  return /** @type{!Array<!proto.io.codedrills.proto.content.AntiCheating>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.io.codedrills.proto.content.AntiCheating, 4));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.AntiCheating>} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
*/
proto.io.codedrills.proto.content.TestMeta.prototype.setAntiCheatingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.io.codedrills.proto.content.AntiCheating=} opt_value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.AntiCheating}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.addAntiCheating = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.io.codedrills.proto.content.AntiCheating, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.clearAntiCheatingList = function() {
  return this.setAntiCheatingList([]);
};


/**
 * optional bool test_by_url_enabled = 5;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getTestByUrlEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.setTestByUrlEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional int64 test_url_expiry = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.TestMeta.prototype.getTestUrlExpiry = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.TestMeta} returns this
 */
proto.io.codedrills.proto.content.TestMeta.prototype.setTestUrlExpiry = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.Ctc.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Ctc.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Ctc.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Ctc} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Ctc.toObject = function(includeInstance, msg) {
  var f, obj = {
    minCtc: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maxCtc: jspb.Message.getFieldWithDefault(msg, 2, 0),
    currency: jspb.Message.getFieldWithDefault(msg, 3, ""),
    minEquity: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    maxEquity: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    otherBenefitsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    paymentFrequency: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Ctc}
 */
proto.io.codedrills.proto.content.Ctc.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Ctc;
  return proto.io.codedrills.proto.content.Ctc.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Ctc} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Ctc}
 */
proto.io.codedrills.proto.content.Ctc.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMinCtc(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMaxCtc(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinEquity(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxEquity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addOtherBenefits(value);
      break;
    case 7:
      var value = /** @type {!proto.io.codedrills.proto.content.PaymentFrequency} */ (reader.readEnum());
      msg.setPaymentFrequency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Ctc.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Ctc.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Ctc} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Ctc.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinCtc();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getMaxCtc();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMinEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMaxEquity();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getOtherBenefitsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPaymentFrequency();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional int64 min_ctc = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getMinCtc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setMinCtc = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 max_ctc = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getMaxCtc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setMaxCtc = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string currency = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double min_equity = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getMinEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setMinEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double max_equity = 5;
 * @return {number}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getMaxEquity = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setMaxEquity = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * repeated string other_benefits = 6;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getOtherBenefitsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setOtherBenefitsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.addOtherBenefits = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.clearOtherBenefitsList = function() {
  return this.setOtherBenefitsList([]);
};


/**
 * optional PaymentFrequency payment_frequency = 7;
 * @return {!proto.io.codedrills.proto.content.PaymentFrequency}
 */
proto.io.codedrills.proto.content.Ctc.prototype.getPaymentFrequency = function() {
  return /** @type {!proto.io.codedrills.proto.content.PaymentFrequency} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.PaymentFrequency} value
 * @return {!proto.io.codedrills.proto.content.Ctc} returns this
 */
proto.io.codedrills.proto.content.Ctc.prototype.setPaymentFrequency = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.JobMeta.repeatedFields_ = [2,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.JobMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.JobMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    locationList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    minExperience: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    maxExperience: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    preferenceList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    postingDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    expiryDate: jspb.Message.getFieldWithDefault(msg, 7, 0),
    candidatesApplied: jspb.Message.getFieldWithDefault(msg, 8, 0),
    ctc: (f = msg.getCtc()) && proto.io.codedrills.proto.content.Ctc.toObject(includeInstance, f),
    companyName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    companyLogoUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
    resumeRequired: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.JobMeta}
 */
proto.io.codedrills.proto.content.JobMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.JobMeta;
  return proto.io.codedrills.proto.content.JobMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.JobMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.JobMeta}
 */
proto.io.codedrills.proto.content.JobMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addLocation(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMinExperience(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxExperience(value);
      break;
    case 5:
      var value = /** @type {!Array<!proto.io.codedrills.proto.content.JobPreference>} */ (reader.readPackedEnum());
      msg.setPreferenceList(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPostingDate(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiryDate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCandidatesApplied(value);
      break;
    case 9:
      var value = new proto.io.codedrills.proto.content.Ctc;
      reader.readMessage(value,proto.io.codedrills.proto.content.Ctc.deserializeBinaryFromReader);
      msg.setCtc(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyLogoUrl(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setResumeRequired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.JobMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.JobMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.JobMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLocationList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getMinExperience();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMaxExperience();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getPreferenceList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getPostingDate();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getExpiryDate();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCandidatesApplied();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCtc();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.io.codedrills.proto.content.Ctc.serializeBinaryToWriter
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCompanyLogoUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getResumeRequired();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional JobType job_type = 1;
 * @return {!proto.io.codedrills.proto.content.JobType}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getJobType = function() {
  return /** @type {!proto.io.codedrills.proto.content.JobType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.JobType} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated string location = 2;
 * @return {!Array<string>}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getLocationList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setLocationList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.addLocation = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.clearLocationList = function() {
  return this.setLocationList([]);
};


/**
 * optional double min_experience = 3;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getMinExperience = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setMinExperience = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double max_experience = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getMaxExperience = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setMaxExperience = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * repeated JobPreference preference = 5;
 * @return {!Array<!proto.io.codedrills.proto.content.JobPreference>}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getPreferenceList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.content.JobPreference>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.content.JobPreference>} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setPreferenceList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.content.JobPreference} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.addPreference = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.clearPreferenceList = function() {
  return this.setPreferenceList([]);
};


/**
 * optional int64 posting_date = 6;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getPostingDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setPostingDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 expiry_date = 7;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getExpiryDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setExpiryDate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 candidates_applied = 8;
 * @return {number}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getCandidatesApplied = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setCandidatesApplied = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional Ctc ctc = 9;
 * @return {?proto.io.codedrills.proto.content.Ctc}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getCtc = function() {
  return /** @type{?proto.io.codedrills.proto.content.Ctc} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.Ctc, 9));
};


/**
 * @param {?proto.io.codedrills.proto.content.Ctc|undefined} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
*/
proto.io.codedrills.proto.content.JobMeta.prototype.setCtc = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.clearCtc = function() {
  return this.setCtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.hasCtc = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string company_name = 10;
 * @return {string}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string company_logo_url = 11;
 * @return {string}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getCompanyLogoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setCompanyLogoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool resume_required = 12;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.JobMeta.prototype.getResumeRequired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.JobMeta} returns this
 */
proto.io.codedrills.proto.content.JobMeta.prototype.setResumeRequired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.DrillMeta.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.DrillMeta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.DrillMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillMeta.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalContent: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.DrillMeta}
 */
proto.io.codedrills.proto.content.DrillMeta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.DrillMeta;
  return proto.io.codedrills.proto.content.DrillMeta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.DrillMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.DrillMeta}
 */
proto.io.codedrills.proto.content.DrillMeta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.DrillMeta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.DrillMeta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.DrillMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.DrillMeta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalContent();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 total_content = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.DrillMeta.prototype.getTotalContent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.DrillMeta} returns this
 */
proto.io.codedrills.proto.content.DrillMeta.prototype.setTotalContent = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Permission.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Permission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Permission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Permission.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    access: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Permission}
 */
proto.io.codedrills.proto.content.Permission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Permission;
  return proto.io.codedrills.proto.content.Permission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Permission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Permission}
 */
proto.io.codedrills.proto.content.Permission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.Access} */ (reader.readEnum());
      msg.setAccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Permission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Permission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Permission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Permission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccess();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.Permission.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Permission} returns this
 */
proto.io.codedrills.proto.content.Permission.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Access access = 2;
 * @return {!proto.io.codedrills.proto.content.Access}
 */
proto.io.codedrills.proto.content.Permission.prototype.getAccess = function() {
  return /** @type {!proto.io.codedrills.proto.content.Access} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.Access} value
 * @return {!proto.io.codedrills.proto.content.Permission} returns this
 */
proto.io.codedrills.proto.content.Permission.prototype.setAccess = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.ContentId.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ContentId.ByCase = {
  BY_NOT_SET: 0,
  ID: 1,
  CONTENT_ADDRESS: 2
};

/**
 * @return {proto.io.codedrills.proto.content.ContentId.ByCase}
 */
proto.io.codedrills.proto.content.ContentId.prototype.getByCase = function() {
  return /** @type {proto.io.codedrills.proto.content.ContentId.ByCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.ContentId.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContentId.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContentId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContentId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentId.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contentAddress: (f = msg.getContentAddress()) && proto.io.codedrills.proto.content.ContentAddress.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.content.ContentId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContentId;
  return proto.io.codedrills.proto.content.ContentId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContentId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContentId}
 */
proto.io.codedrills.proto.content.ContentId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.ContentAddress;
      reader.readMessage(value,proto.io.codedrills.proto.content.ContentAddress.deserializeBinaryFromReader);
      msg.setContentAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContentId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContentId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContentId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContentAddress();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.content.ContentAddress.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.ContentId.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ContentId} returns this
 */
proto.io.codedrills.proto.content.ContentId.prototype.setId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.ContentId.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentId} returns this
 */
proto.io.codedrills.proto.content.ContentId.prototype.clearId = function() {
  return jspb.Message.setOneofField(this, 1, proto.io.codedrills.proto.content.ContentId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentId.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ContentAddress content_address = 2;
 * @return {?proto.io.codedrills.proto.content.ContentAddress}
 */
proto.io.codedrills.proto.content.ContentId.prototype.getContentAddress = function() {
  return /** @type{?proto.io.codedrills.proto.content.ContentAddress} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.ContentAddress, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.ContentAddress|undefined} value
 * @return {!proto.io.codedrills.proto.content.ContentId} returns this
*/
proto.io.codedrills.proto.content.ContentId.prototype.setContentAddress = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.content.ContentId.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ContentId} returns this
 */
proto.io.codedrills.proto.content.ContentId.prototype.clearContentAddress = function() {
  return this.setContentAddress(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ContentId.prototype.hasContentAddress = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ContentAddress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ContentAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentAddress.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    url: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ContentAddress}
 */
proto.io.codedrills.proto.content.ContentAddress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ContentAddress;
  return proto.io.codedrills.proto.content.ContentAddress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ContentAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ContentAddress}
 */
proto.io.codedrills.proto.content.ContentAddress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ContentAddress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ContentAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ContentAddress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional ContentType content_type = 1;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.ContentAddress} returns this
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.ContentAddress} returns this
 */
proto.io.codedrills.proto.content.ContentAddress.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.Attachment.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.Attachment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.Attachment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Attachment.toObject = function(includeInstance, msg) {
  var f, obj = {
    attachmentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    attachmentType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contentId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    isPublic: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    url: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.Attachment}
 */
proto.io.codedrills.proto.content.Attachment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.Attachment;
  return proto.io.codedrills.proto.content.Attachment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.Attachment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.Attachment}
 */
proto.io.codedrills.proto.content.Attachment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setAttachmentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAttachmentType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPublic(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.Attachment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.Attachment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.Attachment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.Attachment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttachmentId();
  if (f !== 0) {
    writer.writeFixed32(
      1,
      f
    );
  }
  f = message.getAttachmentType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getIsPublic();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional fixed32 attachment_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getAttachmentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setAttachmentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string attachment_type = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getAttachmentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setAttachmentType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 content_id = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional bool is_public = 5;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getIsPublic = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setIsPublic = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string url = 6;
 * @return {string}
 */
proto.io.codedrills.proto.content.Attachment.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.Attachment} returns this
 */
proto.io.codedrills.proto.content.Attachment.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.StatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.StatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.StatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.StatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.StatusResponse}
 */
proto.io.codedrills.proto.content.StatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.StatusResponse;
  return proto.io.codedrills.proto.content.StatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.StatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.StatusResponse}
 */
proto.io.codedrills.proto.content.StatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.StatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.StatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.StatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.StatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.StatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.StatusResponse} returns this
 */
proto.io.codedrills.proto.content.StatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.ScoreboardSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.ScoreboardSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    scoreboardType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    penaltyPerAttemptInS: jspb.Message.getFieldWithDefault(msg, 2, 0),
    freezeSettings: (f = msg.getFreezeSettings()) && proto.io.codedrills.proto.content.FreezeSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.ScoreboardSettings;
  return proto.io.codedrills.proto.content.ScoreboardSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.ScoreboardSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.io.codedrills.proto.content.ScoreboardType} */ (reader.readEnum());
      msg.setScoreboardType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPenaltyPerAttemptInS(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.FreezeSettings;
      reader.readMessage(value,proto.io.codedrills.proto.content.FreezeSettings.deserializeBinaryFromReader);
      msg.setFreezeSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.ScoreboardSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.ScoreboardSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.ScoreboardSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScoreboardType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPenaltyPerAttemptInS();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFreezeSettings();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.FreezeSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScoreboardType scoreboard_type = 1;
 * @return {!proto.io.codedrills.proto.content.ScoreboardType}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.getScoreboardType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ScoreboardType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ScoreboardType} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.setScoreboardType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 penalty_per_attempt_in_s = 2;
 * @return {number}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.getPenaltyPerAttemptInS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.setPenaltyPerAttemptInS = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional FreezeSettings freeze_settings = 3;
 * @return {?proto.io.codedrills.proto.content.FreezeSettings}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.getFreezeSettings = function() {
  return /** @type{?proto.io.codedrills.proto.content.FreezeSettings} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.FreezeSettings, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.FreezeSettings|undefined} value
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings} returns this
*/
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.setFreezeSettings = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.ScoreboardSettings} returns this
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.clearFreezeSettings = function() {
  return this.setFreezeSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.ScoreboardSettings.prototype.hasFreezeSettings = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.FreezeSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.FreezeSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FreezeSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    freezeOffsetTimeInS: jspb.Message.getFieldWithDefault(msg, 1, 0),
    unfreeze: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.FreezeSettings}
 */
proto.io.codedrills.proto.content.FreezeSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.FreezeSettings;
  return proto.io.codedrills.proto.content.FreezeSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.FreezeSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.FreezeSettings}
 */
proto.io.codedrills.proto.content.FreezeSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFreezeOffsetTimeInS(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnfreeze(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.FreezeSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.FreezeSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.FreezeSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFreezeOffsetTimeInS();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUnfreeze();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int64 freeze_offset_time_in_s = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.getFreezeOffsetTimeInS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.FreezeSettings} returns this
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.setFreezeOffsetTimeInS = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool unfreeze = 2;
 * @return {boolean}
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.getUnfreeze = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.io.codedrills.proto.content.FreezeSettings} returns this
 */
proto.io.codedrills.proto.content.FreezeSettings.prototype.setUnfreeze = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.EvictCacheItem.CacheItemCase = {
  CACHE_ITEM_NOT_SET: 0,
  CACHED_CONTENT: 1,
  CACHED_TEAM: 2,
  CACHED_SCOREBOARD: 3,
  CACHED_TEAM_MEMBERSHIP: 4,
  CACHED_USER: 5
};

/**
 * @return {proto.io.codedrills.proto.content.EvictCacheItem.CacheItemCase}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCacheItemCase = function() {
  return /** @type {proto.io.codedrills.proto.content.EvictCacheItem.CacheItemCase} */(jspb.Message.computeOneofCase(this, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.EvictCacheItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.EvictCacheItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.EvictCacheItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    cachedContent: (f = msg.getCachedContent()) && proto.io.codedrills.proto.content.CachedContent.toObject(includeInstance, f),
    cachedTeam: (f = msg.getCachedTeam()) && proto.io.codedrills.proto.content.CachedTeam.toObject(includeInstance, f),
    cachedScoreboard: (f = msg.getCachedScoreboard()) && proto.io.codedrills.proto.content.CachedScoreboard.toObject(includeInstance, f),
    cachedTeamMembership: (f = msg.getCachedTeamMembership()) && proto.io.codedrills.proto.content.CachedTeamMembership.toObject(includeInstance, f),
    cachedUser: (f = msg.getCachedUser()) && proto.io.codedrills.proto.content.CachedUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem}
 */
proto.io.codedrills.proto.content.EvictCacheItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.EvictCacheItem;
  return proto.io.codedrills.proto.content.EvictCacheItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.EvictCacheItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem}
 */
proto.io.codedrills.proto.content.EvictCacheItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.io.codedrills.proto.content.CachedContent;
      reader.readMessage(value,proto.io.codedrills.proto.content.CachedContent.deserializeBinaryFromReader);
      msg.setCachedContent(value);
      break;
    case 2:
      var value = new proto.io.codedrills.proto.content.CachedTeam;
      reader.readMessage(value,proto.io.codedrills.proto.content.CachedTeam.deserializeBinaryFromReader);
      msg.setCachedTeam(value);
      break;
    case 3:
      var value = new proto.io.codedrills.proto.content.CachedScoreboard;
      reader.readMessage(value,proto.io.codedrills.proto.content.CachedScoreboard.deserializeBinaryFromReader);
      msg.setCachedScoreboard(value);
      break;
    case 4:
      var value = new proto.io.codedrills.proto.content.CachedTeamMembership;
      reader.readMessage(value,proto.io.codedrills.proto.content.CachedTeamMembership.deserializeBinaryFromReader);
      msg.setCachedTeamMembership(value);
      break;
    case 5:
      var value = new proto.io.codedrills.proto.content.CachedUser;
      reader.readMessage(value,proto.io.codedrills.proto.content.CachedUser.deserializeBinaryFromReader);
      msg.setCachedUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.EvictCacheItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.EvictCacheItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.EvictCacheItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCachedContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.io.codedrills.proto.content.CachedContent.serializeBinaryToWriter
    );
  }
  f = message.getCachedTeam();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.io.codedrills.proto.content.CachedTeam.serializeBinaryToWriter
    );
  }
  f = message.getCachedScoreboard();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.io.codedrills.proto.content.CachedScoreboard.serializeBinaryToWriter
    );
  }
  f = message.getCachedTeamMembership();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.io.codedrills.proto.content.CachedTeamMembership.serializeBinaryToWriter
    );
  }
  f = message.getCachedUser();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.io.codedrills.proto.content.CachedUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional CachedContent cached_content = 1;
 * @return {?proto.io.codedrills.proto.content.CachedContent}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCachedContent = function() {
  return /** @type{?proto.io.codedrills.proto.content.CachedContent} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CachedContent, 1));
};


/**
 * @param {?proto.io.codedrills.proto.content.CachedContent|undefined} value
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
*/
proto.io.codedrills.proto.content.EvictCacheItem.prototype.setCachedContent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.clearCachedContent = function() {
  return this.setCachedContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.hasCachedContent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CachedTeam cached_team = 2;
 * @return {?proto.io.codedrills.proto.content.CachedTeam}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCachedTeam = function() {
  return /** @type{?proto.io.codedrills.proto.content.CachedTeam} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CachedTeam, 2));
};


/**
 * @param {?proto.io.codedrills.proto.content.CachedTeam|undefined} value
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
*/
proto.io.codedrills.proto.content.EvictCacheItem.prototype.setCachedTeam = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.clearCachedTeam = function() {
  return this.setCachedTeam(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.hasCachedTeam = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional CachedScoreboard cached_scoreboard = 3;
 * @return {?proto.io.codedrills.proto.content.CachedScoreboard}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCachedScoreboard = function() {
  return /** @type{?proto.io.codedrills.proto.content.CachedScoreboard} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CachedScoreboard, 3));
};


/**
 * @param {?proto.io.codedrills.proto.content.CachedScoreboard|undefined} value
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
*/
proto.io.codedrills.proto.content.EvictCacheItem.prototype.setCachedScoreboard = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.clearCachedScoreboard = function() {
  return this.setCachedScoreboard(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.hasCachedScoreboard = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional CachedTeamMembership cached_team_membership = 4;
 * @return {?proto.io.codedrills.proto.content.CachedTeamMembership}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCachedTeamMembership = function() {
  return /** @type{?proto.io.codedrills.proto.content.CachedTeamMembership} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CachedTeamMembership, 4));
};


/**
 * @param {?proto.io.codedrills.proto.content.CachedTeamMembership|undefined} value
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
*/
proto.io.codedrills.proto.content.EvictCacheItem.prototype.setCachedTeamMembership = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.clearCachedTeamMembership = function() {
  return this.setCachedTeamMembership(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.hasCachedTeamMembership = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional CachedUser cached_user = 5;
 * @return {?proto.io.codedrills.proto.content.CachedUser}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.getCachedUser = function() {
  return /** @type{?proto.io.codedrills.proto.content.CachedUser} */ (
    jspb.Message.getWrapperField(this, proto.io.codedrills.proto.content.CachedUser, 5));
};


/**
 * @param {?proto.io.codedrills.proto.content.CachedUser|undefined} value
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
*/
proto.io.codedrills.proto.content.EvictCacheItem.prototype.setCachedUser = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.io.codedrills.proto.content.EvictCacheItem.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.io.codedrills.proto.content.EvictCacheItem} returns this
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.clearCachedUser = function() {
  return this.setCachedUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.io.codedrills.proto.content.EvictCacheItem.prototype.hasCachedUser = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CachedContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CachedContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    contentType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contentUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    contentVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CachedContent}
 */
proto.io.codedrills.proto.content.CachedContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CachedContent;
  return proto.io.codedrills.proto.content.CachedContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CachedContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CachedContent}
 */
proto.io.codedrills.proto.content.CachedContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {!proto.io.codedrills.proto.content.ContentType} */ (reader.readEnum());
      msg.setContentType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setContentUrl(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CachedContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CachedContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getContentType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getContentUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getContentVersion();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CachedContent} returns this
 */
proto.io.codedrills.proto.content.CachedContent.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ContentType content_type = 2;
 * @return {!proto.io.codedrills.proto.content.ContentType}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.getContentType = function() {
  return /** @type {!proto.io.codedrills.proto.content.ContentType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.io.codedrills.proto.content.ContentType} value
 * @return {!proto.io.codedrills.proto.content.CachedContent} returns this
 */
proto.io.codedrills.proto.content.CachedContent.prototype.setContentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string content_url = 3;
 * @return {string}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.getContentUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CachedContent} returns this
 */
proto.io.codedrills.proto.content.CachedContent.prototype.setContentUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 content_version = 4;
 * @return {number}
 */
proto.io.codedrills.proto.content.CachedContent.prototype.getContentVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CachedContent} returns this
 */
proto.io.codedrills.proto.content.CachedContent.prototype.setContentVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CachedTeam.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CachedTeam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CachedTeam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedTeam.toObject = function(includeInstance, msg) {
  var f, obj = {
    teamId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CachedTeam}
 */
proto.io.codedrills.proto.content.CachedTeam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CachedTeam;
  return proto.io.codedrills.proto.content.CachedTeam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CachedTeam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CachedTeam}
 */
proto.io.codedrills.proto.content.CachedTeam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTeamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CachedTeam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CachedTeam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CachedTeam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedTeam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTeamId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 team_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.CachedTeam.prototype.getTeamId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CachedTeam} returns this
 */
proto.io.codedrills.proto.content.CachedTeam.prototype.setTeamId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CachedScoreboard.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CachedScoreboard.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CachedScoreboard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedScoreboard.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CachedScoreboard}
 */
proto.io.codedrills.proto.content.CachedScoreboard.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CachedScoreboard;
  return proto.io.codedrills.proto.content.CachedScoreboard.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CachedScoreboard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CachedScoreboard}
 */
proto.io.codedrills.proto.content.CachedScoreboard.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CachedScoreboard.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CachedScoreboard.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CachedScoreboard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedScoreboard.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.CachedScoreboard.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CachedScoreboard} returns this
 */
proto.io.codedrills.proto.content.CachedScoreboard.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CachedTeamMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CachedTeamMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedTeamMembership.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CachedTeamMembership}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CachedTeamMembership;
  return proto.io.codedrills.proto.content.CachedTeamMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CachedTeamMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CachedTeamMembership}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setContentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CachedTeamMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CachedTeamMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedTeamMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional int32 content_id = 1;
 * @return {number}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.getContentId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.io.codedrills.proto.content.CachedTeamMembership} returns this
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.setContentId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CachedTeamMembership} returns this
 */
proto.io.codedrills.proto.content.CachedTeamMembership.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.CachedUser.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.CachedUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.CachedUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.CachedUser}
 */
proto.io.codedrills.proto.content.CachedUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.CachedUser;
  return proto.io.codedrills.proto.content.CachedUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.CachedUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.CachedUser}
 */
proto.io.codedrills.proto.content.CachedUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.CachedUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.CachedUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.CachedUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.CachedUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_id = 1;
 * @return {string}
 */
proto.io.codedrills.proto.content.CachedUser.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.io.codedrills.proto.content.CachedUser} returns this
 */
proto.io.codedrills.proto.content.CachedUser.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.io.codedrills.proto.content.LanguageRestriction.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.toObject = function(opt_includeInstance) {
  return proto.io.codedrills.proto.content.LanguageRestriction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.io.codedrills.proto.content.LanguageRestriction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.LanguageRestriction.toObject = function(includeInstance, msg) {
  var f, obj = {
    allowLanguageList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    denyLanguageList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.content.LanguageRestriction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.io.codedrills.proto.content.LanguageRestriction;
  return proto.io.codedrills.proto.content.LanguageRestriction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.io.codedrills.proto.content.LanguageRestriction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction}
 */
proto.io.codedrills.proto.content.LanguageRestriction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.Language>} */ (reader.readPackedEnum());
      msg.setAllowLanguageList(value);
      break;
    case 2:
      var value = /** @type {!Array<!proto.io.codedrills.proto.judge.Language>} */ (reader.readPackedEnum());
      msg.setDenyLanguageList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.io.codedrills.proto.content.LanguageRestriction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.io.codedrills.proto.content.LanguageRestriction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.io.codedrills.proto.content.LanguageRestriction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllowLanguageList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getDenyLanguageList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
};


/**
 * repeated io.codedrills.proto.judge.Language allow_language = 1;
 * @return {!Array<!proto.io.codedrills.proto.judge.Language>}
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.getAllowLanguageList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.Language>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Language>} value
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.setAllowLanguageList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.addAllowLanguage = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.clearAllowLanguageList = function() {
  return this.setAllowLanguageList([]);
};


/**
 * repeated io.codedrills.proto.judge.Language deny_language = 2;
 * @return {!Array<!proto.io.codedrills.proto.judge.Language>}
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.getDenyLanguageList = function() {
  return /** @type {!Array<!proto.io.codedrills.proto.judge.Language>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.io.codedrills.proto.judge.Language>} value
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.setDenyLanguageList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.io.codedrills.proto.judge.Language} value
 * @param {number=} opt_index
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.addDenyLanguage = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.io.codedrills.proto.content.LanguageRestriction} returns this
 */
proto.io.codedrills.proto.content.LanguageRestriction.prototype.clearDenyLanguageList = function() {
  return this.setDenyLanguageList([]);
};


/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.PublishType = {
  PRIVATE: 0,
  PUBLIC: 1,
  URL: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.AntiCheatingSettings = {
  ANTI_CHEATING_UNKNOWN: 0,
  ANTI_CHEATING_DISALLOW_COPY: 1,
  ANTI_CHEATING_FULL_SCREEN: 2,
  ANTI_CHEATING_TAB_CHANGE: 3,
  ANTI_CHEATING_CAMERA_SNAP: 4
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.McqType = {
  MCQ_SINGLE_ANSWER: 0,
  MCQ_MULTIPLE_ANSWER: 1
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.SkillLevel = {
  SKILL_LEVEL_UNKNOWN: 0,
  SKILL_LEVEL_BEGINNER: 1,
  SKILL_LEVEL_INTERMEDIATE: 2,
  SKILL_LEVEL_ADVANCE: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.FillInTheBlanksMatchType = {
  FILL_IN_THE_BLANKS_MATCH_TYPE_UNKNOWN: 0,
  FILL_IN_THE_BLANKS_MATCH_TYPE_CASE_SENSITIVE: 1,
  FILL_IN_THE_BLANKS_MATCH_TYPE_CASE_INSENSITIVE: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.TeamNameUniqueness = {
  TEAM_NAME_UNIQUENESS_UNKNOWN: 0,
  TEAM_NAME_DUPLICATE_ALLOWED: 1,
  TEAM_NAME_UNIQUE_REQUIRED: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.CustomAttributeType = {
  CUSTOM_ATTRIBUTE_TYPE_UNKNOWN: 0,
  CUSTOM_ATTRIBUTE_TYPE_STRING: 1,
  CUSTOM_ATTRIBUTE_TYPE_NUMBER: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.FieldPresence = {
  FIELD_PRESENCE_UNKNOWN: 0,
  FIELD_PRESENCE_REQUIRED: 1,
  FIELD_PRESENCE_OPTIONAL: 2
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ContestType = {
  UNKNOWN_CONTEST_TYPE: 0,
  TEAM_CONTEST: 1
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.JobType = {
  JOB_TYPE_UNKNOWN: 0,
  FULL_TIME: 1,
  INTERNSHIP: 2,
  CONTRACT: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.JobPreference = {
  JOB_PREFERENCE_UNKNOWN: 0,
  REMOTE: 1,
  ONSITE: 2,
  HYBRID: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.PaymentFrequency = {
  PAYMENT_FREQUENCY_UNKNOWN: 0,
  PAYMENT_PER_MONTH: 1,
  PAYMENT_PER_ANNUM: 2,
  PAYMENT_PER_PROJECT: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.Access = {
  READ_ONLY: 0,
  AUTHOR: 1,
  TESTER: 2,
  EDITORIALIST: 3
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ContentType = {
  PROBLEM: 0,
  ARTICLE: 1,
  DRILL: 2,
  CONTEST: 3,
  EXTERNAL_LINK: 4,
  TEST: 5,
  MCQ: 6,
  SKILL: 7,
  SUBJECTIVE: 8,
  JOB: 9,
  FILL_IN_THE_BLANKS: 10,
  MATCH_THE_FOLLOWING: 11,
  ORDER_THE_FOLLOWING: 12
};

/**
 * @enum {number}
 */
proto.io.codedrills.proto.content.ScoreboardType = {
  UNKNOWN_SCOREBOARD_TYPE: 0,
  ONE_POINT_WITH_PENALTY: 1
};

goog.object.extend(exports, proto.io.codedrills.proto.content);
